import {css} from 'styled-components';

import {toReadonly} from '../../../core/src/helpers/typescript/typeHelpers';
import {makeSizeConstants} from './styleHelpers';

/*
 * Font collections.
 */

/** Main font collections. */
export const fonts = toReadonly({
  /** @deprecated Use uiFontStyle instead when possible. */
  ui: `
    Inter,
    sans-serif,
    'Apple Color Emoji',
    'Segoe UI Emoji',
    'Segoe UI Symbol',
    'Noto Color Emoji'
  `,
  system: `
    system-ui,
    sans-serif,
    'Apple Color Emoji',
    'Segoe UI Emoji',
    'Segoe UI Symbol',
    'Noto Color Emoji'
  `,
});

export const uiFontStyle = css`
  font-family: Inter, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
  font-feature-settings:
    'liga' 1,
    'calt' 1; /* fix for Chrome */

  @supports (font-variation-settings: normal) {
    font-family: InterVariable, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
      'Noto Color Emoji';
  }
`;

export const monospaceFontStyle = css`
  font-family: monaco, Consolas, 'Lucida Console', monospace;
  font-feature-settings: initial;
`;

/*
 * Font sizes.
 */

/** Main font-size map. */
/** @deprecated Use <Typography> & `typographyMixin` instead. */
export const fontSizes = toReadonly({
  hardToRead: '9px',
  veryTiny: '10px',
  tiny: '11px',
  verySmall: '12px',
  small: '13px',
  medium: '14px',
  large: '16px',
  veryLarge: '18px',
  huge: '24px',
} as const);

/** Secondary text font-size map. */
export const visualFontSizes = makeSizeConstants(fontSizes.small, fontSizes.medium, fontSizes.large);
export const secondaryFontSizes = makeSizeConstants('12px', '13px', '15px');
export const tertiaryFontSizes = makeSizeConstants(
  fontSizes.verySmall,
  fontSizes.verySmall,
  fontSizes.medium,
);

/*
 * Font weights.
 */

/** @deprecated Use <Typography> & `typographyMixin` instead. */
export const fontWeights = toReadonly({
  thin: 100,
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  black: 800,
} as const);
